import { Component, OnInit } from "@angular/core";
import { MessageService } from "base";
import { ConfigurationService } from "configuration/services/configuration.service";
import { ServerSettingsDto } from "UvExplorerServer.Dtos.TS/Configuration/ServerSettingsDto";

@Component({
    templateUrl: './server-settings.component.html',
    styleUrls: ['./server-settings.component.scss'],
    selector: 'server-settings',
})
export class ServerSettingsComponent implements OnInit {

    settings: ServerSettingsDto = new ServerSettingsDto();

    constructor(
        private configurationService: ConfigurationService,
        private messageService: MessageService) {
    }

    ngOnInit() {
        this.getServerSettings();
    }

    private getServerSettings() {
        this.configurationService.getServerSettings().subscribe(
            data => {
                this.settings = data;
            },
            error => {
                console.error(error);
                this.messageService.displayErrorMessage("Failed to get server settings");
            }
        );
    }

    saveServerSettings() {
        this.configurationService.setServerSettings(this.settings).subscribe(
            data => {},
            error => this.messageService.displayErrorMessage("Failed to update server settings")
        );
    }
}
